import { render, staticRenderFns } from "./AssignRiscossione.vue?vue&type=template&id=08e68a9e&"
import script from "./AssignRiscossione.vue?vue&type=script&lang=ts&"
export * from "./AssignRiscossione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports